const pkg = require('../../package.json');

import { UserInfo } from '../app/shared/models/user-info.model';


/**
 * Base environment config (shared settings for all environments go here)
 */
export const environment = {
  /**
   * Application name (shown in page title)
   */
  appName: 'AOPA Airports',

  /**
   * Application version
   */
  version: pkg.version,

  /**
   * Base URL for instrument procedure downloads
   */
  iapBaseUrl: 'https://download.aopa.org/iap',

  /**
   * Raven DSN (Data Source Name) for error logging
   */
  ravenDsn: 'https://e44f340988fe4ea1ad0fad2affeb1243@sentry.io/204662',

  /**
   * Setting to force logging to Sentry (regardless of environment). May be used to validate that logging works
   * correctly. By default, errors only get logged if in an environment other than development.
   */
  forceLogging: false,

  /**
   * Redirect URL for 404 errors
   */
  notFoundUrl: 'https://www.aopa.org/404-error',

  /**
   * Redirect URL for internal errors
   */
  errorUrl: 'https://www.aopa.org/error.html',

  /**
   * URL of the login page
   */
  loginUrl: 'https://www.aopa.org/login',

  /**
   * Base URL of the authentication server
   */
  authUrl: 'https://authapistage.aopa.org/identity',

  /**
   * Client ID to use when authenticating as an end user.
   */
  clientIdUser: 'AOPAAirportsUser',

  /**
   * Client secret to use when authenticating as an end user. Note that because the angular app is not a confidential
   * client, this is not actually a "secret" (IdentityServer3 still requires that a secret is passed in).
   */
  clientSecretUser: '97E2AD8D-2DCC-4224-9E79-BC1C10E51464',

  /**
   * Client ID to use when requesting an anonymous token on behalf of the client application (end user not logged in).
   */
  clientIdAnon: 'AOPAAirports',

  /**
   * Client secret to use when authenticating as the application. (Again, not really a secret, but IdentityServer3
   * requires it.)
   */
  clientSecretAnon: 'F08FA387-580B-4C0B-8443-DB694B9207A2',

  /**
   * List of scopes to request when authenticating as an end user.
   */
  authScopesUser: 'AirportsAPI offline_access',

  /**
   * List of scopes to request when authenticating as the application.
   */
  authScopesAnon: 'AirportsAPI',

  /**
   * Mock user info for authentication
   */
  mockUser: null,

  /**
   * URL for the AOPA skin web service
   */
  skinServiceUrl: 'https://www.aopa.org/webservices/skin/aopa'
};
